import React from 'react';
import './ContactInfo.css';
const ContactInfo = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "Krisara Gastro and Liver Clinic",
    "image": "https://yourclinicimage.com/logo.png", // replace with actual logo/image URL
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500014",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 17.5297451,
      "longitude": 78.4876595
    },
    "url": "https://krisaragastro.com/", // your website URL
    "telephone": "+917569541532",
    "email": "infor@krisara.com",
    "openingHours": [
      "Mo-Su 07:30-08:30",
      "Mo-Su 18:30-21:00"
    ]
  };
  return (
    <section className="ccd-contact-container" aria-label="Contact information for Krisara Gastro and Liver Clinic">
      {/* Google Map */}
      <div className="ccd-map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.5339936639934!2d78.48765949999999!3d17.529745099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb85bbfd0172fd%3A0x7fa24177c42a2214!2sKrisara%20Gastro%20and%20Liver%20Clinic%20(%20Dr.Shruti%20Sagar%20Gastroenterologist%20)!5e0!3m2!1sen!2sin!4v1758791775536!5m2!1sen!2sin"
          width="500"
          height="350"
          style={{ borderRadius: "16px", border: "none" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Krisara Gastro and Liver Clinic Location"
        ></iframe>
      </div>
      {/* Contact Info */}
      <address className="ccd-contact-info">
        <div className="ccd-location-info">
          <div className="ccd-location-pin" aria-hidden="true"></div>
          <div className="ccd-location-text" style={{ textDecoration: 'none', color: 'black' }}>
            <p>We are located at</p>
            <p>
              <a
                href="https://maps.app.goo.gl/pMDttjbMyYpotVyF9"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="Open Krisara Gastro and Liver Clinic location in Google Maps"
                style={{ textDecoration: 'none', color: 'black' }}
              >
                3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally, Hyderabad, Secunderabad, Telangana 500014
              </a>
            </p>
          </div>
        </div>
        <div className="ccd-email-info">
          <div className="ccd-email-icon" aria-hidden="true"></div>
          <p>
            Email:{' '}
            <a href="mailto:infor@krisara.com" style={{ textDecoration: 'none', color: 'black' }} aria-label="Send email to infor@krisara.com">
              infor@krisara.com
            </a>
          </p>
        </div>
        <div className="ccd-phone-info">
          <div className="ccd-phone-icon" aria-hidden="true"></div>
          <p>
            Phone:{' '}
            <a href="tel:+917569541532" style={{ textDecoration: 'none', color: 'black' }} aria-label="Call +91 7569541532">
              +91 7569541532
            </a>
          </p>
        </div>
        <div className="ccd-hours-info">
          <div className="ccd-hours-icon" aria-hidden="true"></div>
          <p>
            Working hours:{' '}
            <time dateTime="07:30-08:30">7:30AM – 8:30 AM</time> & <time dateTime="18:30-21:00">6:30PM – 9PM</time>
          </p>
        </div>
      </address>
      {/* JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </section>
  );
};
export default ContactInfo;